export default "__VITE_ASSET__B9S_XrhF__"